import { Box, Typography } from "@mui/material";
import {
  AppearanceBlock,
  GeneralNavigationBlock,
  LanguageBlock,
  PersonalDataBlock,
  ProfileHeader,
  ReferralBlock,
  SocialMediaBlock,
} from "../../components/pages/profile";
import { useNavigate } from "react-router-dom";
import { useTelegram } from "../../hooks";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const APP_VERSION = process.env.REACT_APP_VERSION || "0.1.0";

export function ProfilePage() {
  const navigate = useNavigate();
  const { t } = useTranslation("profile");

  const { tg } = useTelegram();
  useEffect(() => {
    const handleBack = () => navigate("/");
    tg.BackButton.show();
    tg.onEvent("backButtonClicked", handleBack);

    return () => {
      tg.BackButton.hide();
      tg.offEvent("backButtonClicked", handleBack);
    };
  }, [navigate, tg]);

  return (
    <Box
      sx={{
        marginBottom: "100px",
        width: "100%",
      }}
    >
      <ProfileHeader />

      <Box sx={{ display: "grid", gap: "14px", marginTop: "18px" }}>
        <ReferralBlock />
        <PersonalDataBlock />
        <AppearanceBlock />
        <LanguageBlock />
        <GeneralNavigationBlock />
        <SocialMediaBlock />
      </Box>

      <Typography
        sx={{
          textAlign: "center",
          fontSize: "11px",
          fontWeight: 500,
          color: "text.secondary",
          opacity: 0.6,
          marginTop: "22px",
          letterSpacing: "0.4px",
        }}
      >
        {t("footer.version", { version: APP_VERSION })}
      </Typography>
    </Box>
  );
}
